/**
 * @module Core
 */

import * as AnimationsLib from '@pixelunion/animations';
import * as BreakpointsLib from '@pixelunion/breakpoint';
import EventHandler from '@pixelunion/events';
import ComponentManager from './components/ComponentManager';
import ComponentClass from './components/Component';
import SectionComponentClass from './components/SectionComponent';
import BlockComponentClass from './components/BlockComponent';
import A11yHelpers from './helpers/a11y';
import UtilsHelpers from './helpers/Utils';
import MoneyHelpers from './helpers/Money';
import MediaHelpers from './helpers/Media';

/**
 * The animation library
 * @see {@link https://github.com/pixelunion/animations|Animations}
 */
export const Animations = AnimationsLib;

/**
 * The breakpoint library
 * @see {@link https://github.com/pixelunion/breakpoint|Breakpoints}
 */
export const Breakpoints = BreakpointsLib;

/**
 * A global instance of the event handler
 * @see {@link https://github.com/pixelunion/events|Events}
 */
export const Events = new EventHandler();

/**
 * A global instance of the component manager
 * @see {@link lib/components/README.md#ComponentManager|ComponentManager}
 */
export const Components = new ComponentManager();

/**
 * The component class
 * @see {@link lib/components/README.md#Component|Component}
 */
export const Component = ComponentClass;

/**
 * The section component class
 * @see {@link lib/components/README.md#SectionComponent|SectionComponent}
 */
export const SectionComponent = SectionComponentClass;

/**
 * The block component class
 * @see {@link lib/components/README.md#BlockComponent|BlockComponent}
 */
export const BlockComponent = BlockComponentClass;

/**
 * Accessbility helpers
 * @see {@link lib/helpers/README.md#Ally|A11y}
 */
export const A11y = A11yHelpers;

/**
 * Utility helpers
 * @see {@link lib/helpers/README.md#Utils|Utils}
 */
export const Utils = UtilsHelpers;

export const Money = MoneyHelpers;

export const Media = MediaHelpers;
